import { useEffect } from "react";
import { __ } from "@/i18n";
import { TooltipProvider } from "@/components/ui/tooltip";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";

import Banner from "./components/ui/banner";
import ReviewBanner from "./components/ui/review-banner";
import ConsultationBanner from "./components/ui/consultation-banner";
import { Header } from "./components/header";
import { useWidgetStore } from "./stores/widget-store";
import SkeletonLoader from "./components/skeleton-loader";
import { SonnerProvider } from "./components/ui/sonner-provider";
import { CustomizeTab } from "./components/tabs/customize-tab";
import { SettingsTab } from "./components/tabs/settings-tab";
import { StatementGeneratorTab } from "./components/tabs/statement-generator-tab";
import { ModulesTab } from "./components/tabs/modules-tab";

export default function App() {
  const { isLoading, fetchConfig } = useWidgetStore();
  useEffect(() => {
    fetchConfig();
  }, [fetchConfig]);

  return (
    <SonnerProvider>
      <TooltipProvider>
        <div className="cy:min-h-screen">
          <Header />
          {isLoading ? (
            <div className="cy:max-w-7xl cy:mx-auto cy:px-4 cy:sm:px-6 cy:lg:px-8 cy:py-8 cy:relative cy:min-h-[600px]">
              <SkeletonLoader />
            </div>
          ) : (
            <Tabs defaultValue="customize" className="cy:w-full">
              <TabsList className="cy:w-full cy:flex cy:justify-start cy:h-[56px] cy:bg-white cy:border-b cy:rounded-none cy:py-0">
                <div className="cy:max-w-7xl cy:px-4 cy:sm:px-6 cy:lg:px-8 cy:h-[56px] cy:mx-auto cy:w-full">
                  <TabsTrigger
                    value="customize"
                    className="cy:-mb-1 cy:flex-none  cy:border-0 cy:border-b-3 cy:border-transparent cy:data-[state=active]:border-b-4 cy:data-[state=active]:border-primary cy:data-[state=active]:text-text-dark cy:rounded-none cy:shadow-none cy:data-[state=active]:shadow-none cy:p-0 cy:px-0 cy:ml-0 cy:mr-4 cy:text-base! cy:font-medium"
                  >
                    {__( 'Customise widget', 'accessibility-widget' )}
                  </TabsTrigger>
                  <TabsTrigger
                    value="statement"
                    className="cy:-mb-1 cy:flex-none cy:border-0 cy:border-b-3 cy:border-transparent cy:data-[state=active]:border-b-4 cy:data-[state=active]:border-primary cy:data-[state=active]:text-text-dark cy:rounded-none cy:shadow-none cy:data-[state=active]:shadow-none cy:p-0 cy:px-0 cy:mx-4 cy:text-base! cy:font-medium"
                  >
                    {__( 'Statement', 'accessibility-widget' )}
                  </TabsTrigger>
                  <TabsTrigger
                    value="settings"
                    className="cy:-mb-1 cy:flex-none cy:border-0 cy:border-b-3  cy:border-transparent cy:data-[state=active]:border-b-4 cy:data-[state=active]:border-primary cy:data-[state=active]:text-text-dark cy:rounded-none cy:shadow-none cy:data-[state=active]:shadow-none cy:p-0 cy:px-0 cy:mx-4 cy:text-base! cy:font-medium"
                  >
                    {__( 'Settings', 'accessibility-widget' )}
                  </TabsTrigger>
                  <TabsTrigger
                    value="modules"
                    className="cy:-mb-1 cy:flex-none cy:border-0 cy:border-b-3  cy:border-transparent cy:data-[state=active]:border-b-4 cy:data-[state=active]:border-primary cy:data-[state=active]:text-text-dark cy:rounded-none cy:shadow-none cy:data-[state=active]:shadow-none cy:p-0 cy:px-0 cy:mx-4 cy:text-base! cy:font-medium"
                  >
                    {__( 'Modules', 'accessibility-widget' )}
                  </TabsTrigger>
                </div>
              </TabsList>

              <div className="cy:w-full">
                <Banner />
                <ConsultationBanner />
                <ReviewBanner />
              </div>

              <TabsContent value="customize">
                <CustomizeTab />
              </TabsContent>

              <TabsContent value="statement">
                <StatementGeneratorTab />
              </TabsContent>

              <TabsContent value="settings">
                <SettingsTab />
              </TabsContent>

              <TabsContent value="modules">
                <ModulesTab />
              </TabsContent>
            </Tabs>
          )}

          <div className="cy:px-4 cy:py-4 cy:sm:px-6 cy:lg:px-8 cy:max-w-7xl cy:mx-auto cy:flex cy:justify-between">
            <p className="cy:text-[13px] cy:font-[300] cy:text-black">
              {__( 'Please rate AccessiYes', 'accessibility-widget' )}{" "}
              <a
                href="https://wordpress.org/support/plugin/accessibility-widget/reviews/#new-post"
                target="_blank"
                rel="noopener noreferrer"
                className="cy:text-[#1863DC] cy:no-underline hover:cy:underline"
              >
                ★★★★★
              </a>{" "}
              {__( 'on', 'accessibility-widget' )}{" "}
              <a
                href="https://wordpress.org/support/plugin/accessibility-widget/reviews/#new-post"
                target="_blank"
                rel="noopener noreferrer"
                className="cy:text-[#1863DC] cy:no-underline hover:cy:underline"
              >
                WordPress.org
              </a>{" "}
              {__( 'to help us spread the word. Thank you from the team AccessiYes!', 'accessibility-widget' )}
            </p>
            <p className="cy:text-[13px] cy:font-[300] cy:text-black">
              Version {window.cyA11yGlobals?.version ?? ''}
            </p>
          </div>
        </div>
      </TooltipProvider>
    </SonnerProvider>
  );
}
